function g2oHexToRgb(hex, fallback) {
  if (!hex) return fallback;
  hex = hex.trim().replace('#', '');
  if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
  if (hex.length !== 6) return fallback;
  var num = parseInt(hex, 16);
  if (isNaN(num)) return fallback;
  return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
}

function g2oGetBrandStops() {
  var css = getComputedStyle(document.documentElement);
  return [
    g2oHexToRgb(css.getPropertyValue('--g2o-pink'), [231, 0, 126]),
    g2oHexToRgb(css.getPropertyValue('--g2o-orange'), [245, 100, 6]),
    g2oHexToRgb(css.getPropertyValue('--g2o-purple'), [119, 12, 233])
  ];
}

document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var burger = document.querySelector('[data-g2o-burger]');
  var mobileNav = document.querySelector('[data-g2o-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('[data-g2o-select]').forEach(function (wrap) {
    var trigger = wrap.querySelector('[data-g2o-select-trigger]');
    var panel = wrap.querySelector('[data-g2o-select-panel]');
    var native = wrap.querySelector('[data-g2o-select-native]');
    var label = wrap.querySelector('[data-g2o-select-label]');
    if (!trigger || !panel || !native) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      document.querySelectorAll('.g2o-select.is-open').forEach(function (w) { if (w !== wrap) w.classList.remove('is-open'); });
      wrap.classList.toggle('is-open');
    });
    panel.querySelectorAll('[data-value]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        native.value = opt.getAttribute('data-value');
        if (label) label.textContent = opt.textContent;
        panel.querySelectorAll('.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        wrap.classList.remove('is-open');
      });
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.g2o-select.is-open').forEach(function (w) { w.classList.remove('is-open'); });
  });

  document.querySelectorAll('[data-g2o-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var accordion = btn.closest('.g2o-mobile-accordion');
      if (!accordion) return;
      var wasOpen = accordion.classList.contains('is-open');
      document.querySelectorAll('.g2o-mobile-accordion.is-open').forEach(function (a) {
        if (a !== accordion) a.classList.remove('is-open');
      });
      accordion.classList.toggle('is-open', !wasOpen);
    });
  });

  // Generic contact forms -> SuiteCRM via app proxy
  document.querySelectorAll('[data-g2o-crm-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var endpoint = form.getAttribute('data-endpoint') || '/apps/suitecrm-lead';
      var statusEl = form.querySelector('[data-form-status]');
      var payload = {};
      new FormData(form).forEach(function (value, key) { payload[key] = value; });
      if (statusEl) { statusEl.textContent = 'Enviando…'; }
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { if (!res.ok) throw new Error('bad response'); return res.json(); })
        .then(function () {
          form.reset();
          window.location.href = form.getAttribute('data-thank-you-url') || '/pages/gracias';
        })
        .catch(function () {
          if (statusEl) statusEl.textContent = 'Hubo un error al enviar. Escribinos a info@grow2on.com.';
        });
    });
  });

  // ---- Stats row: globe canvas + particle canvases (ported 1:1 from design reference) ----
  initStatGlobe();
  initCardParticles();
  initHeroParticles();
  initCtaParticles();
  initSyncParticles();
  initClickToPlayVideo();
  initFlexxusWizard();

  // ---- Header mega-menus: hover (200ms close delay) + click + click-outside ----
  var menuBackdrop = document.querySelector('[data-g2o-menu-backdrop]');
  function updateMenuBackdrop() {
    if (!menuBackdrop) return;
    var anyOpen = document.querySelector('.g2o-func-menu.is-open, .g2o-int-menu.is-open');
    menuBackdrop.classList.toggle('is-open', !!anyOpen);
  }
  function initMegaMenu(selector) {
    var menu = document.querySelector(selector);
    if (!menu) return;
    var closeTimer = null;
    menu.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      menu.classList.add('is-open');
      updateMenuBackdrop();
    });
    menu.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        menu.classList.remove('is-open');
        updateMenuBackdrop();
      }, 200);
    });
    document.addEventListener('click', function (e) {
      if (!menu.contains(e.target)) {
        menu.classList.remove('is-open');
        updateMenuBackdrop();
      }
    });
  }
  initMegaMenu('.g2o-func-menu');
  initMegaMenu('.g2o-int-menu');

  // ---- Highlight the target card when arriving via a #func-* anchor from the Funcionalidades dropdown ----
  function g2oHighlightAnchorTarget(hash) {
    if (!hash || hash.indexOf('#func-') !== 0) return;
    var el = document.getElementById(hash.slice(1));
    if (!el) return;
    el.classList.remove('g2o-anchor-highlight');
    void el.offsetWidth; // force reflow so the animation restarts even if re-triggered
    el.classList.add('g2o-anchor-highlight');
    el.addEventListener('animationend', function () {
      el.classList.remove('g2o-anchor-highlight');
    }, { once: true });
  }
  if (window.location.hash) {
    setTimeout(function () { g2oHighlightAnchorTarget(window.location.hash); }, 400);
  }
  window.addEventListener('hashchange', function () {
    setTimeout(function () { g2oHighlightAnchorTarget(window.location.hash); }, 300);
  });
  document.querySelectorAll('.g2o-func-mega a[href*="#func-"]').forEach(function (link) {
    link.addEventListener('click', function () {
      var url = new URL(link.href, window.location.origin);
      if (url.pathname === window.location.pathname && url.hash === window.location.hash) {
        setTimeout(function () { g2oHighlightAnchorTarget(url.hash); }, 100);
      }
    });
  });

  // ---- Integrations landing: category filter tabs (desktop pills + mobile dropdown) ----
  var filterBtns = document.querySelectorAll('.g2o-int-filter__btn, .g2o-int-filter__mobile-opt');
  if (filterBtns.length) {
    var catSections = document.querySelectorAll('.g2o-int-cat');
    var mobileWrap = document.querySelector('[data-int-filter-mobile]');
    var mobileToggle = document.querySelector('[data-int-filter-toggle]');
    var mobileLabel = document.querySelector('[data-int-filter-mobile-label]');
    var mobileCount = document.querySelector('[data-int-filter-mobile-count]');

    function applyFilter(filter, label, count) {
      filterBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-filter') === filter);
      });
      catSections.forEach(function (sec) {
        var match = filter === 'todas' || sec.getAttribute('data-category') === filter;
        sec.classList.toggle('is-hidden', !match);
      });
      if (mobileLabel) mobileLabel.textContent = label;
      if (mobileCount) mobileCount.textContent = count;
      if (mobileWrap) mobileWrap.classList.remove('is-open');
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.getAttribute('data-filter');
        var label = btn.getAttribute('data-filter-label') || filter;
        var badge = btn.querySelector('.g2o-int-filter__badge, .g2o-int-filter__mobile-opt-badge');
        var count = badge ? badge.textContent : '';
        applyFilter(filter, label, count);
      });
    });

    if (mobileToggle && mobileWrap) {
      mobileToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        mobileWrap.classList.toggle('is-open');
      });
      document.addEventListener('click', function (e) {
        if (mobileWrap.classList.contains('is-open') && !mobileWrap.contains(e.target)) {
          mobileWrap.classList.remove('is-open');
        }
      });
    }
  }

  // ---- FAQ accordions ----
  document.querySelectorAll('[data-g2o-faq]').forEach(function (faq) {
    faq.querySelectorAll('.g2o-faq__item').forEach(function (item) {
      var btn = item.querySelector('.g2o-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        faq.querySelectorAll('.g2o-faq__item').forEach(function (i) { i.classList.remove('is-open'); });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  });

  // ---- Platform hub: staggered reveal on scroll into view ----
  var hubTrack = document.querySelector('.g2o-hub-track');
  if (hubTrack) {
    var hubIo = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        hubTrack.querySelectorAll('.g2o-hub-node').forEach(function (node) {
          node.classList.add('is-revealed');
        });
        hubIo.disconnect();
      }
    }, { threshold: 0.15 });
    hubIo.observe(hubTrack);
  }
});

function buildStatGlobePoints(canvas) {
  var dpr = window.devicePixelRatio || 1;
  var w = canvas.clientWidth, h = canvas.clientHeight;
  canvas.width = w * dpr; canvas.height = h * dpr;
  canvas._dpr = dpr;
  var seed = 5;
  function rand() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
  function isLand(lat, lon) {
    if (lat < -63) return true;
    if (lat > 60 && lat < 83 && lon > -73 && lon < -12) return true;
    if (lat > 15 && lat < 72 && lon > -168 && lon < -52) return true;
    if (lat > -56 && lat < 13 && lon > (-82 + (12 - lat) * 0.15) && lon < -34) return true;
    if (lat > 36 && lat < 71 && lon > -10 && lon < 40) return true;
    if (lat > -35 && lat < 37 && lon > -18 && lon < 52) return true;
    if (lat > 5 && lat < 77 && lon > 40 && lon <= 180) return true;
    if (lat > 5 && lat < 77 && lon >= -180 && lon < -170) return true;
    if (lat > -44 && lat < -10 && lon > 112 && lon < 154) return true;
    return false;
  }
  var points = [];
  var attempts = 0;
  while (points.length < 2400 && attempts < 70000) {
    attempts++;
    var theta = Math.acos(1 - 2 * rand());
    var phi0 = rand() * Math.PI * 2;
    var latDeg = 90 - theta * 180 / Math.PI;
    var lonDeg = (phi0 * 180 / Math.PI) % 360;
    lonDeg = ((lonDeg + 180) % 360 + 360) % 360 - 180;
    if (!isLand(latDeg, lonDeg)) continue;
    points.push({ theta: theta, phi0: phi0, r: (0.35 + rand() * 0.55) * dpr });
  }
  canvas._points = points;
}

function startStatGlobeLoop(canvas, logoUrls) {
  var ctx = canvas.getContext('2d');
  var t = 0;
  var visible = true;
  var stops = g2oGetBrandStops();
  function colorFor(frac) {
    var f = Math.min(1, Math.max(0, frac));
    var idx = f < 0.5 ? 0 : 1;
    var lf = f < 0.5 ? f * 2 : (f - 0.5) * 2;
    var a = stops[idx], b = stops[idx + 1];
    return [Math.round(a[0] + (b[0] - a[0]) * lf), Math.round(a[1] + (b[1] - a[1]) * lf), Math.round(a[2] + (b[2] - a[2]) * lf)];
  }
  var logoImgs = logoUrls.map(function (src) { var img = new Image(); img.src = src; return img; });
  var companies = [
    { price: '$14.590', logo: logoImgs[0] },
    { price: '$8.250', logo: logoImgs[1] },
    { price: '$22.900', logo: logoImgs[2] },
    { price: '$5.780', logo: logoImgs[3] },
    { price: '$31.400', logo: logoImgs[4] },
    { price: '$1.240', logo: logoImgs[5] }
  ];
  var GAP_START = 1.75 * Math.PI, GAP_END = 2 * Math.PI + 0.12 * Math.PI, ARC_START = 0.12 * Math.PI;
  var orbits = [
    { rx: 0, ry: 0, rotSpeed: 0.16, phase: 0, color: 'rgba(119,12,233,0.28)' },
    { rx: 0, ry: 0, rotSpeed: -0.11, phase: 2.4, color: 'rgba(231,0,126,0.24)' },
    { rx: 0, ry: 0, rotSpeed: 0.1, phase: 4.2, color: 'rgba(245,100,6,0.24)' }
  ];
  var cards = null;

  var io = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.01 });
  io.observe(canvas);
  var ro = new ResizeObserver(function () { buildStatGlobePoints(canvas); });
  ro.observe(canvas);

  var lastT = 0;
  function step(nowT) {
    requestAnimationFrame(step);
    if (!visible) return;
    if (lastT && nowT - lastT < 66) return;
    lastT = nowT;
    t += 0.022;
    var w = canvas.width, h = canvas.height;
    ctx.clearRect(0, 0, w, h);
    var cx = w / 2;
    var R = h * 0.62;
    var cy = h * 0.78;
    var dpr = canvas._dpr || 1;

    orbits[0].rx = R * 1.02; orbits[0].ry = R * 0.36;
    orbits[1].rx = R * 1.08; orbits[1].ry = R * 0.42;
    orbits[2].rx = R * 0.98; orbits[2].ry = R * 0.3;

    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(cx, cy, R, 0, Math.PI * 2);
    ctx.fill();
    ctx.save();
    ctx.beginPath();
    ctx.arc(cx, cy, R, 0, Math.PI * 2);
    ctx.clip();

    orbits.forEach(function (orbit) {
      var orbitAngle = t * orbit.rotSpeed + orbit.phase;
      ctx.save();
      ctx.translate(cx, cy);
      ctx.rotate(orbitAngle);
      ctx.scale(1, orbit.ry / orbit.rx);
      ctx.beginPath();
      ctx.arc(0, 0, orbit.rx, ARC_START, GAP_START);
      ctx.strokeStyle = orbit.color;
      ctx.lineWidth = dpr * 0.7;
      ctx.stroke();
      ctx.restore();
    });

    function orbitPoint(orbit, angle) {
      var orbitAngle = t * orbit.rotSpeed + orbit.phase;
      var lx = orbit.rx * Math.cos(angle), ly = orbit.ry * Math.sin(angle);
      var cosA = Math.cos(orbitAngle), sinA = Math.sin(orbitAngle);
      return { x: cx + lx * cosA - ly * sinA, y: cy + lx * sinA + ly * cosA };
    }

    if (!cards) {
      cards = [0, 1, 2].map(function (i) {
        return {
          orbitIdx: i % orbits.length,
          angle: ARC_START + Math.random() * (GAP_START - ARC_START),
          speed: 0.85 + Math.random() * 0.15,
          company: companies[Math.floor(Math.random() * companies.length)]
        };
      });
    }
    cards.forEach(function (card) {
      card.angle += card.speed * 0.016;
      if (card.angle > GAP_END) {
        card.angle -= (GAP_END - ARC_START);
        card.company = companies[Math.floor(Math.random() * companies.length)];
      }
    });

    var pts = (canvas._points || []).map(function (p) {
      var phi = p.phi0 + t;
      var x3 = Math.sin(p.theta) * Math.cos(phi);
      var y3 = Math.cos(p.theta);
      var z3 = Math.sin(p.theta) * Math.sin(phi);
      return { x: cx + x3 * R, y: cy - y3 * R, z: z3, r: p.r, xf: (x3 + 1) / 2 };
    }).filter(function (p) { return p.y < h + 4 && p.z > -0.15; }).sort(function (a, b) { return a.z - b.z; });

    pts.forEach(function (p) {
      var c = colorFor(p.xf);
      var depth = (p.z + 1) / 2;
      var opacity = 0.5 + depth * 0.5;
      ctx.fillStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + opacity + ')';
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * (0.75 + depth * 0.5), 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.restore();

    var FADE = 0.18;
    cards.forEach(function (card) {
      var distStart = card.angle - ARC_START, distEnd = GAP_START - card.angle;
      var alpha = Math.max(0, Math.min(1, Math.min(distStart / FADE, distEnd / FADE)));
      if (alpha <= 0.02) return;
      var orbit = orbits[card.orbitIdx];
      var pos = orbitPoint(orbit, card.angle);
      ctx.save();
      ctx.globalAlpha = alpha;
      var pad = 6 * dpr, logoR = 7 * dpr;
      var priceFont = '700 ' + Math.round(8 * dpr) + 'px Geist, sans-serif';
      ctx.font = priceFont;
      var priceW = ctx.measureText(card.company.price).width;
      var cw = pad + logoR * 2 + pad * 0.8 + priceW + pad, ch = 24 * dpr;
      var x0 = pos.x - cw / 2, y0 = pos.y - ch / 2;
      ctx.fillStyle = '#ffffff';
      ctx.strokeStyle = 'rgba(20,20,40,0.08)';
      ctx.lineWidth = dpr * 0.6;
      ctx.shadowColor = 'rgba(20,20,40,0.25)';
      ctx.shadowBlur = 7 * dpr;
      ctx.shadowOffsetY = 2 * dpr;
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(x0, y0, cw, ch, 6 * dpr); else ctx.rect(x0, y0, cw, ch);
      ctx.fill();
      ctx.shadowColor = 'transparent'; ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
      ctx.stroke();
      var logoCx = x0 + pad + logoR, logoCy = pos.y;
      ctx.save();
      ctx.beginPath();
      if (ctx.roundRect) ctx.roundRect(logoCx - logoR, logoCy - logoR, logoR * 2, logoR * 2, 3 * dpr); else ctx.rect(logoCx - logoR, logoCy - logoR, logoR * 2, logoR * 2);
      ctx.clip();
      if (card.company.logo && card.company.logo.naturalWidth) {
        ctx.drawImage(card.company.logo, logoCx - logoR, logoCy - logoR, logoR * 2, logoR * 2);
      } else {
        ctx.fillStyle = '#eee';
        ctx.fillRect(logoCx - logoR, logoCy - logoR, logoR * 2, logoR * 2);
      }
      ctx.restore();
      ctx.textAlign = 'left';
      ctx.fillStyle = '#1a1a1e';
      ctx.font = priceFont;
      ctx.fillText(card.company.price, logoCx + logoR + pad * 0.8, pos.y + 0.5 * dpr);
      ctx.restore();
    });
  }
  requestAnimationFrame(step);
}

function initStatGlobe() {
  var canvas = document.getElementById('g2o-stat-globe-canvas');
  if (!canvas) return;
  var logoUrls = (canvas.getAttribute('data-logos') || '').split(',').filter(Boolean);
  buildStatGlobePoints(canvas);
  startStatGlobeLoop(canvas, logoUrls);
}

function startCardParticles(canvas, mouseObj) {
  if (!canvas) return;
  var w, h, points, visible = true;
  var seed = 7;
  function rand() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
  var topClearFrac = canvas.dataset.topClear !== undefined ? parseFloat(canvas.dataset.topClear) : 0.42;
  function build() {
    w = canvas.clientWidth; h = canvas.clientHeight;
    canvas.width = w; canvas.height = h;
    var topClear = h * topClearFrac;
    points = [];
    for (var i = 0; i < 20; i++) {
      var baseX = rand() * w, baseY = topClear + rand() * (h - topClear);
      points.push({ baseX: baseX, baseY: baseY, x: baseX, y: baseY, amp: 3 + rand() * 6, phase: rand() * 10, z: rand() * 2 - 1, r: 0.7 + rand() * 0.9 });
    }
  }
  build();
  var ro = new ResizeObserver(build);
  ro.observe(canvas);
  var io = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.01 });
  io.observe(canvas);
  var ctx = canvas.getContext('2d');
  var stops = g2oGetBrandStops();
  function colorFor(frac) {
    var f = Math.min(1, Math.max(0, frac));
    var idx = f < 0.5 ? 0 : 1;
    var lf = f < 0.5 ? f * 2 : (f - 0.5) * 2;
    var a = stops[idx], b = stops[idx + 1];
    return [Math.round(a[0] + (b[0] - a[0]) * lf), Math.round(a[1] + (b[1] - a[1]) * lf), Math.round(a[2] + (b[2] - a[2]) * lf)];
  }
  var t = 0, lastT = 0;
  function step(now) {
    requestAnimationFrame(step);
    if (!visible || now - lastT < 90) return;
    lastT = now;
    t += 0.03;
    ctx.clearRect(0, 0, w, h);
    var topClear = h * topClearFrac;
    points.forEach(function (p) {
      var waveY = p.baseY + Math.sin(p.baseX * 0.05 + p.phase + t) * p.amp;
      var targetX = p.baseX, targetY = Math.max(topClear, waveY);
      if (mouseObj.active) {
        var dx = p.x - mouseObj.x, dy = p.y - mouseObj.y;
        var dist = Math.hypot(dx, dy) || 1;
        var radius = 46;
        if (dist < radius) {
          var force = (radius - dist) / radius;
          targetX = p.x + (dx / dist) * force * 12;
          targetY = Math.max(topClear, p.y + (dy / dist) * force * 12);
        }
      }
      p.x += (targetX - p.x) * 0.12;
      p.y += (targetY - p.y) * 0.12;
      var c = colorFor(p.baseX / w);
      var opacity = 0.5 + (p.z + 1) / 2 * 0.5;
      ctx.fillStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + opacity + ')';
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    });
  }
  requestAnimationFrame(step);
}

// Ported literally from design-reference/Integraciones.dc.html (buildHeroParticles / startHeroLoop /
// handleHeroMouseMove / handleHeroMouseLeave) — React `this.state` refs swapped for plain closures.
function initHeroParticles() {
  document.querySelectorAll('[data-g2o-particle-canvas]').forEach(initHeroParticleCanvas);
}

function initHeroParticleCanvas(canvas) {
  var wrap = canvas.closest('[data-g2o-hero-particles]') || canvas.parentElement;

  var heroMouse = { x: 0, y: 0, active: false };
  var heroParticles = [];
  var heroCenter = { cx: 0, cy: 0 };
  var heroBaseR = 0;

  function handleHeroMouseMove(e) {
    var rect = wrap.getBoundingClientRect();
    heroMouse.x = e.clientX - rect.left;
    heroMouse.y = e.clientY - rect.top;
    heroMouse.active = true;
  }
  function handleHeroMouseLeave() { heroMouse.active = false; }

  function buildHeroParticles() {
    var w = canvas.clientWidth, h = canvas.clientHeight;
    canvas.width = w; canvas.height = h;
    var cx = w / 2, cy = h / 2;
    var baseR = Math.min(w, h) * 0.46;
    heroCenter = { cx: cx, cy: cy };
    heroBaseR = baseR;
    var rings = [0.6, 0.8, 1.0, 1.18];
    var particles = [];
    var seed = 11;
    function rand() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    rings.forEach(function (rf, ringIdx) {
      var count = 9 + ringIdx * 2;
      for (var i = 0; i < count; i++) {
        if (rand() < 0.12) continue;
        var angle = (i / count) * Math.PI * 2 + rand() * 0.5;
        var radius = baseR * rf * (0.94 + rand() * 0.14);
        var p = {
          angle: angle, radius: radius,
          speed: (ringIdx % 2 === 0 ? 1 : -1) * (0.1 + rand() * 0.05),
          phase: rand() * Math.PI * 2,
          z: rand() * 2 - 1,
          r: 1.1 + rand() * 1.1
        };
        p.x = cx + Math.cos(angle) * radius;
        p.y = cy + Math.sin(angle) * radius;
        particles.push(p);
      }
    });
    heroParticles = particles;
  }

  function startHeroLoop() {
    var ctx = canvas.getContext('2d');
    var t = 0;
    var stops = g2oGetBrandStops();
    function colorFor(frac) {
      var f = Math.min(1, Math.max(0, frac));
      var idx = f < 0.5 ? 0 : 1;
      var lf = f < 0.5 ? f * 2 : (f - 0.5) * 2;
      var a = stops[idx], b = stops[idx + 1];
      return [
        Math.round(a[0] + (b[0] - a[0]) * lf),
        Math.round(a[1] + (b[1] - a[1]) * lf),
        Math.round(a[2] + (b[2] - a[2]) * lf)
      ];
    }
    function step() {
      t += 0.006;
      if (canvas.width !== canvas.clientWidth || canvas.height !== canvas.clientHeight) buildHeroParticles();
      var w = canvas.width, h = canvas.height;
      ctx.clearRect(0, 0, w, h);
      var cx = heroCenter.cx, cy = heroCenter.cy;
      var wobAmp = heroBaseR * 0.05;
      var mouse = heroMouse;
      heroParticles.forEach(function (p) {
        var ang = p.angle + t * p.speed;
        var wob = Math.sin(t * 1.4 + p.phase) * wobAmp;
        var baseX = cx + Math.cos(ang) * (p.radius + wob);
        var baseY = cy + Math.sin(ang) * (p.radius + wob);
        var targetX = baseX, targetY = baseY;
        if (mouse.active) {
          var dx = p.x - mouse.x, dy = p.y - mouse.y;
          var dist = Math.hypot(dx, dy) || 1;
          var radius = 80;
          if (dist < radius) {
            var force = (radius - dist) / radius;
            targetX = p.x + (dx / dist) * force * 34;
            targetY = p.y + (dy / dist) * force * 34;
          }
        }
        p.x += (targetX - p.x) * 0.08;
        p.y += (targetY - p.y) * 0.08;
        var frac = (Math.cos(ang) + 1) / 2;
        var c = colorFor(frac);
        var opacity = 0.55 + (p.z + 1) / 2 * 0.45;
        ctx.fillStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + opacity + ')';
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r * 1.6, 0, Math.PI * 2);
        ctx.fill();
      });
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  buildHeroParticles();
  startHeroLoop();
  var ro = new ResizeObserver(function () { buildHeroParticles(); });
  ro.observe(canvas);
  wrap.addEventListener('mousemove', handleHeroMouseMove);
  wrap.addEventListener('mouseleave', handleHeroMouseLeave);
}

// Ported literally from design-reference (buildCtaParticles / startCtaLoop) — used by every
// "¿No ves tu plataforma en la lista?" / CTA-final style banner across Home, Funcionalidades,
// ¿Sos un ERP? and all individual integration landing pages (they all share the cta-banner section).
function buildCtaParticles(canvas) {
  var w = canvas.clientWidth, h = canvas.clientHeight;
  canvas.width = w; canvas.height = h;
  var cols = Math.max(34, Math.round(w / 13));
  var rows = 30;
  var particles = [];
  var seed = 7;
  function rand() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
  function ridgeY(cf) { return 0.28 + Math.sin(cf * Math.PI * 1.6 + 0.6) * 0.12 + Math.sin(cf * Math.PI * 3.1) * 0.05; }
  for (var r = 0; r < rows; r++) {
    var rf = r / (rows - 1);
    for (var c = 0; c < cols; c++) {
      var cf = c / (cols - 1);
      var distFromRidge = Math.abs(rf - ridgeY(cf));
      var skipChance = 0.08 + distFromRidge * 1.35;
      if (rand() < skipChance) continue;
      var baseX = cf * w + (rand() - 0.5) * (w / cols) * 1.6;
      var baseY = h - (rf * h + (rand() - 0.5) * (h / rows) * 1.8);
      var zoneRx = Math.min(w * 0.42, 340), zoneRy = h * 0.24, zoneCy = h * 0.32;
      var ndx = (baseX - w / 2) / zoneRx, ndy = (baseY - zoneCy) / zoneRy;
      if (ndx * ndx + ndy * ndy < 1) continue;
      var amp = (4 + Math.max(0, 1 - distFromRidge * 3.2) * 9) * (0.6 + rand() * 0.7);
      var z = rand() * 2 - 1;
      particles.push({ baseX: baseX, baseY: baseY, x: baseX, y: baseY, amp: amp, phase: r * 0.3 + c * 0.1, z: z, r: (0.55 + rand() * 0.6) * (1 + z * 0.5) });
    }
  }
  return particles;
}

function startCtaLoop(canvas, particles, mouse) {
  var ctx = canvas.getContext('2d');
  var t = 0;
  var stops = g2oGetBrandStops();
  function colorFor(frac) {
    var f = Math.min(1, Math.max(0, frac));
    var idx = f < 0.5 ? 0 : 1;
    var lf = f < 0.5 ? f * 2 : (f - 0.5) * 2;
    var a = stops[idx], b = stops[idx + 1];
    return [Math.round(a[0] + (b[0] - a[0]) * lf), Math.round(a[1] + (b[1] - a[1]) * lf), Math.round(a[2] + (b[2] - a[2]) * lf)];
  }
  function step() {
    t += 0.0022;
    var w = canvas.width, h = canvas.height;
    ctx.clearRect(0, 0, w, h);
    var breathing = 1 + Math.sin(t * 1.3) * 0.15;
    particles.forEach(function (p) {
      var waveY = p.baseY + Math.sin(p.baseX * 0.012 + p.phase + t) * p.amp * breathing;
      var targetX = p.baseX, targetY = waveY;
      if (mouse.active) {
        var dx = p.x - mouse.x, dy = p.y - mouse.y;
        var dist = Math.hypot(dx, dy) || 1;
        var radius = 90;
        if (dist < radius) {
          var force = (radius - dist) / radius;
          targetX = p.x + (dx / dist) * force * 16;
          targetY = p.y + (dy / dist) * force * 16;
        }
      }
      p.x += (targetX - p.x) * 0.06;
      p.y += (targetY - p.y) * 0.06;
      var c = colorFor(p.baseX / w);
      var opacity = 0.5 + (p.z + 1) / 2 * 0.5;
      ctx.fillStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + opacity + ')';
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * 1.3, 0, Math.PI * 2);
      ctx.fill();
    });
    requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function initCtaParticles() {
  document.querySelectorAll('[data-g2o-cta-particles]').forEach(function (wrap) {
    var canvas = wrap.querySelector('canvas.g2o-cta-particles-canvas');
    if (!canvas) return;
    var mouse = { x: 0, y: 0, active: false };
    var particles = buildCtaParticles(canvas);
    var ro = new ResizeObserver(function () {
      var fresh = buildCtaParticles(canvas);
      particles.length = 0;
      Array.prototype.push.apply(particles, fresh);
    });
    ro.observe(canvas);
    wrap.addEventListener('mousemove', function (e) {
      var rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
      mouse.active = true;
    });
    wrap.addEventListener('mouseleave', function () { mouse.active = false; });
    startCtaLoop(canvas, particles, mouse);
  });
}

// Adapted from buildCtaParticles/startCtaLoop for the "Sincroniza" section (¿Sos un ERP?) — a
// simpler grid (no ridge, no hand-tuned exclusion zone; the empty area behind the heading/paragraph
// is done with a CSS canvas mask, same trick as the cta-banner/tagline-particles canvases) since the
// design handoff explicitly allows a simplified particle layout as long as it doesn't cover the text.
function buildSyncParticles(canvas) {
  var w = canvas.clientWidth, h = canvas.clientHeight;
  canvas.width = w; canvas.height = h;
  var cols = Math.max(28, Math.round(w / 16));
  var rows = 22;
  var particles = [];
  var seed = 13;
  function rand() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
  for (var r = 0; r < rows; r++) {
    for (var c = 0; c < cols; c++) {
      if (rand() < 0.15) continue;
      var baseX = (c / (cols - 1)) * w + (rand() - 0.5) * (w / cols) * 1.6;
      var baseY = (r / (rows - 1)) * h + (rand() - 0.5) * (h / rows) * 1.8;
      var z = rand() * 2 - 1;
      particles.push({ baseX: baseX, baseY: baseY, x: baseX, y: baseY, amp: 3 + rand() * 6, phase: r * 0.3 + c * 0.15, z: z, r: (0.5 + rand() * 0.55) * (1 + z * 0.4) });
    }
  }
  return particles;
}

function initSyncParticles() {
  document.querySelectorAll('[data-g2o-sync-particles]').forEach(function (wrap) {
    var canvas = wrap.querySelector('canvas.g2o-sync-particles-canvas');
    if (!canvas) return;
    var mouse = { x: 0, y: 0, active: false };
    var particles = buildSyncParticles(canvas);
    var ro = new ResizeObserver(function () {
      var fresh = buildSyncParticles(canvas);
      particles.length = 0;
      Array.prototype.push.apply(particles, fresh);
    });
    ro.observe(canvas);
    wrap.addEventListener('mousemove', function (e) {
      var rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
      mouse.active = true;
    });
    wrap.addEventListener('mouseleave', function () { mouse.active = false; });
    startCtaLoop(canvas, particles, mouse);
  });
}

// Click-to-play poster for embedded video sections (e.g. "Potencia" on ¿Sos un ERP?, sections/centered-video.liquid):
// shows a static poster image with a play button and only loads/plays the iframe after a click.
function initClickToPlayVideo() {
  document.querySelectorAll('[data-g2o-video-poster]').forEach(function (el) {
    el.addEventListener('click', function () {
      var src = el.getAttribute('data-embed-src');
      if (!src) return;
      var title = el.getAttribute('data-embed-title') || '';
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = title;
      iframe.style.cssText = 'width:100%;height:100%;display:block;border:0;';
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      el.innerHTML = '';
      el.appendChild(iframe);
      el.style.cursor = 'default';
    }, { once: true });
  });
}

// Ported literally from design-reference/"Flexxus + Grow2on.dc.html" (React state machine -> plain JS).
function initFlexxusWizard() {
  var root = document.querySelector('[data-g2o-flexxus-wizard]');
  if (!root) return;

  var endpoint = root.getAttribute('data-endpoint') || '/apps/suitecrm-lead';
  var channelMeta = {
    tiendanube: { label: 'Tienda Nube' },
    mercadolibre: { label: 'Mercado Libre' },
    shopify: { label: 'Shopify' }
  };
  var stepOrder = ['company', 'catalog', 'channel-operation', 'channel-done', 'infra', 'infra-requirements', 'config', 'account', 'confirm', 'own-store', 'done'];
  var stepToGroup = { company: 0, catalog: 1, 'channel-operation': 2, 'channel-done': 2, infra: 3, 'infra-requirements': 3, config: 4, account: 5, confirm: 6, 'own-store': 6, done: 6 };

  var state = {
    step: 'company',
    history: [],
    channelQueue: [],
    channelIndex: 0,
    data: {
      razonSocial: '', cuit: '', nombreFantasia: '', email: '', celular: '', ejecutivo: '',
      channels: { tiendanube: false, mercadolibre: false, shopify: false },
      catalogSize: '',
      channelConfigs: {},
      serverType: '', infraAccept: false, ipDdns: '', dbPath: '',
      listaPrecios: '', deposito: '', tipoStock: '', articuloEnvio: '', vendedor: '', tipoOperacion: '', condicionVenta: '', usaTalles: '',
      accNombre: '', accApellido: '', accEmail: '', accCelular: '', accPassword: '',
      comentario: '', ownStore: ''
    }
  };

  function currentChannel() { return state.channelQueue[state.channelIndex]; }
  function currentChannelConfig() {
    var ch = currentChannel();
    if (!ch) return {};
    return state.data.channelConfigs[ch] || {};
  }

  function showError(msg) {
    var el = root.querySelector('[data-fw-error]');
    if (!el) return;
    el.textContent = msg;
    el.style.display = msg ? 'block' : 'none';
  }

  function render() {
    root.querySelectorAll('[data-fw-step]').forEach(function (el) {
      el.style.display = el.getAttribute('data-fw-step') === state.step ? '' : 'none';
    });

    var progress = root.querySelector('[data-fw-progress]');
    if (progress) progress.style.display = (state.step === 'own-store' || state.step === 'done') ? 'none' : 'flex';
    var activeGroup = stepToGroup[state.step] || 0;
    root.querySelectorAll('[data-fw-progress-step]').forEach(function (el) {
      var i = parseInt(el.getAttribute('data-fw-progress-step'), 10);
      el.classList.toggle('is-active', i === activeGroup);
      el.classList.toggle('is-done', i < activeGroup);
    });

    var ch = currentChannel();
    var label = ch ? channelMeta[ch].label : '';
    root.querySelectorAll('[data-fw-current-channel-label]').forEach(function (el) { el.textContent = label; });

    root.querySelectorAll('[data-fw-only-channel]').forEach(function (el) {
      el.style.display = el.getAttribute('data-fw-only-channel') === ch ? '' : 'none';
    });

    root.querySelectorAll('[data-fw-channel]').forEach(function (btn) {
      btn.classList.toggle('is-active', !!state.data.channels[btn.getAttribute('data-fw-channel')]);
    });

    var cfg = currentChannelConfig();
    root.querySelectorAll('[data-fw-opt]').forEach(function () {});
    root.querySelectorAll('.g2o-fw__opt').forEach(function (btn) {
      var group = btn.getAttribute('data-fw-group');
      var val = btn.getAttribute('data-fw-value');
      var current;
      if (group === 'catalogSize') current = state.data.catalogSize;
      else if (group === 'productos' || group === 'publicaciones' || group === 'pedidos' || group === 'full') current = cfg[group];
      else current = state.data[group];
      btn.classList.toggle('is-active', current === val);
    });

    if (state.step === 'channel-done') {
      var hasMore = state.channelIndex + 1 < state.channelQueue.length;
      var moreEl = root.querySelector('[data-fw-has-more-channels]');
      var noMoreEl = root.querySelector('[data-fw-no-more-channels]');
      if (moreEl) moreEl.style.display = hasMore ? 'block' : 'none';
      if (noMoreEl) noMoreEl.style.display = hasMore ? 'none' : 'block';
    }

    if (state.step === 'confirm') {
      var d = state.data;
      var selected = Object.keys(d.channels).filter(function (k) { return d.channels[k]; }).map(function (k) { return channelMeta[k].label; }).join(', ');
      var summary = root.querySelector('[data-fw-summary]');
      if (summary) {
        summary.innerHTML =
          '<div><b>' + escapeHtml(d.razonSocial) + '</b> · CUIT ' + escapeHtml(d.cuit) + '</div>' +
          '<div>' + escapeHtml(d.email) + ' · ' + escapeHtml(d.celular) + '</div>' +
          '<div>Canales: ' + escapeHtml(selected) + '</div>';
      }
    }

    showError('');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function goTo(step) {
    state.history.push(state.step);
    state.step = step;
    render();
  }
  function goBack() {
    state.step = state.history.pop() || 'company';
    render();
  }

  // Text/select/textarea/checkbox fields -> state.data
  root.querySelectorAll('[data-fw-field]').forEach(function (input) {
    var field = input.getAttribute('data-fw-field');
    var evt = (input.tagName === 'SELECT') ? 'change' : 'input';
    input.addEventListener(evt, function () {
      if (input.type === 'checkbox') state.data[field] = input.checked;
      else state.data[field] = input.value;
    });
  });

  // Channel multi-select toggles
  root.querySelectorAll('[data-fw-channel]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var ch = btn.getAttribute('data-fw-channel');
      state.data.channels[ch] = !state.data.channels[ch];
      render();
    });
  });

  // Single-select pill groups (catalogSize, productos/publicaciones/pedidos/full per channel, serverType, tipoStock, usaTalles)
  root.querySelectorAll('.g2o-fw__opt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.getAttribute('data-fw-group');
      var val = btn.getAttribute('data-fw-value');
      if (group === 'catalogSize') {
        state.data.catalogSize = val;
      } else if (group === 'productos' || group === 'publicaciones' || group === 'pedidos' || group === 'full') {
        var ch = currentChannel();
        if (!ch) return;
        if (!state.data.channelConfigs[ch]) state.data.channelConfigs[ch] = {};
        state.data.channelConfigs[ch][group] = val;
      } else {
        state.data[group] = val;
      }
      render();
    });
  });

  root.querySelectorAll('[data-fw-back]').forEach(function (btn) { btn.addEventListener('click', goBack); });

  root.querySelectorAll('[data-fw-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var from = btn.getAttribute('data-fw-next');
      var d = state.data;

      if (from === 'company') {
        if (!d.razonSocial || !d.cuit || !d.email || !d.celular || !d.ejecutivo) { showError('Completá los campos obligatorios.'); return; }
        goTo('catalog');
      } else if (from === 'catalog') {
        var chans = Object.keys(d.channels).filter(function (k) { return d.channels[k]; });
        if (chans.length === 0 || !d.catalogSize) { showError('Seleccioná al menos un canal y el tamaño de tu catálogo.'); return; }
        state.channelQueue = chans;
        state.channelIndex = 0;
        goTo('channel-operation');
      } else if (from === 'channel-operation') {
        var ch = currentChannel();
        var cfg = d.channelConfigs[ch] || {};
        if (!cfg.productos || !cfg.publicaciones || !cfg.pedidos || (ch === 'mercadolibre' && !cfg.full)) { showError('Completá todos los campos de este canal.'); return; }
        goTo('channel-done');
      } else if (from === 'infra') {
        if (!d.serverType) { showError('Seleccioná dónde está alojado tu servidor.'); return; }
        goTo(d.serverType === 'propio' ? 'infra-requirements' : 'config');
      } else if (from === 'infra-requirements') {
        if (!d.infraAccept || !d.ipDdns || !d.dbPath) { showError('Completá los datos de conexión y aceptá los requisitos.'); return; }
        goTo('config');
      } else if (from === 'config') {
        if (!d.listaPrecios || !d.deposito || !d.tipoStock || !d.articuloEnvio || !d.vendedor || !d.tipoOperacion || !d.condicionVenta || !d.usaTalles) { showError('Completá la configuración de Flexxus.'); return; }
        goTo('account');
      } else if (from === 'account') {
        if (!d.accNombre || !d.accApellido || !d.accEmail || !d.accCelular || !d.accPassword) { showError('Completá tus datos de cuenta.'); return; }
        goTo('confirm');
      }
    });
  });

  root.querySelectorAll('[data-fw-channel-done-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nextIdx = state.channelIndex + 1;
      if (nextIdx < state.channelQueue.length) { state.channelIndex = nextIdx; goTo('channel-operation'); }
      else goTo('infra');
    });
  });
  root.querySelectorAll('[data-fw-channel-done-later]').forEach(function (btn) {
    btn.addEventListener('click', function () { goTo('infra'); });
  });

  root.querySelectorAll('[data-fw-submit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var payload = JSON.parse(JSON.stringify(state.data));
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(function () {});
      goTo('own-store');
    });
  });

  root.querySelectorAll('[data-fw-own-store]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.data.ownStore = btn.getAttribute('data-fw-own-store');
      goTo('done');
    });
  });

  render();
}

function initCardParticles() {
  document.querySelectorAll('[data-g2o-particles]').forEach(function (wrap) {
    var canvas = wrap.querySelector('canvas.g2o-stat-particles-canvas');
    if (!canvas) return;
    var mouse = { x: 0, y: 0, active: false };
    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      mouse.x = e.clientX - rect.left; mouse.y = e.clientY - rect.top; mouse.active = true;
    });
    wrap.addEventListener('mouseleave', function () { mouse.active = false; });
    startCardParticles(canvas, mouse);
  });
}
